<template>
  <div id="contenedor-tiposobra-main">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'TiposObraMain',
  data() {
    return {};
  },

};
</script>

<style lang="scss">

</style>
